<!--
 *  AEConnect.portal - a Web Application for Archimede Energia's Battery
 *
 *  Copyright (C) 2023-2024 Vincenzo Barbato (vincenzo.barbato@archimede-energia.com)
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 *
 *
 * This code is made available on the understanding that it will not be
 * used in safety-critical situations without a full and competent review.
 -->

<div class="block" *ngIf="!this.view_manage_user">
  <div>
    <p class="title">Manage users</p>
  </div>
  <div>
    <div class="list_message">
      {{ this.users.dashboard_message }}
    </div>
    <div>
      <div class="search_list">
        <img
          class="search"
          src="../../assets/icon/device-list/device_list_menu/search.svg"
          alt=""
        />
        <input
          id="search_log_access_list_input"
          class="input"
          type="text"
          placeholder="Search for a user"
          (input)="this.filtered_sorted_list()"
        />
      </div>
      <div class="sort_list_label">Sort by</div>
      <div class="sort_list">
        <select
          class="input"
          name="sort_options"
          id="sort_options"
        >
          <option value="name">Name</option>
          <option class="company" value="company">Company</option>
          <option class="created_on" value="last_created">Last created</option>
          <option class="created_on" value="oldest_created">Oldest created</option>
          <option value="status">Status</option>
        </select>
      </div>
    </div>
  </div>
  <div class="fixed_table">
    <table class="list">
      <thead>
        <tr>
          <th class="small_td">ID</th>
          <th>Name</th>
          <th class="email">Email</th>
          <th class="company">Company</th>
          <th class="large_td created_on">Created on</th>
          <th class="middle_td">Status</th>
          <th class="extra_small_td"></th>
        </tr>
      </thead>
      <tbody id="log_access_list_body">
        <tr
          *ngFor="
            let user of this.filtered_sorted_list();
            let i = index
          "
        >
          <td
            class="small_td"
            [ngStyle]="{ background: i % 2 != 0 ? 'rgb(60,60,60)' : '' }"
          >
            {{ user.account_id }}
          </td>
          <td [ngStyle]="{ background: i % 2 != 0 ? 'rgb(60,60,60)' : '' }">
            <div style="float: left; padding: 1px 4px 1px 4px">
              {{ user.account_name }}
            </div>

            <div *ngIf="user.admin" class="admin">Admin</div>
          </td>
          <td
            class="email"
            [ngStyle]="{ background: i % 2 != 0 ? 'rgb(60,60,60)' : '' }"
          >
            {{ user.account_email }}
          </td>
          <td
            class="company"
            [ngStyle]="{ background: i % 2 != 0 ? 'rgb(60,60,60)' : '' }"
          >
            {{ user.account_company }}
          </td>
          <td
            class="large_td created_on"
            [ngStyle]="{ background: i % 2 != 0 ? 'rgb(60,60,60)' : '' }"
          >
            {{ this.users.formatDate(user.account_date) }}
          </td>
          <td
            class="middle_td"
            [ngStyle]="{ background: i % 2 != 0 ? 'rgb(60,60,60)' : '' }"
          >
            {{ user.account_is_valid ? "Verified" : "Pending" }}
          </td>
          <td
            class="extra_small_td"
            [ngStyle]="{ background: i % 2 != 0 ? 'rgb(60,60,60)' : '' }"
          >
            <img
              class="open_icon"
              [ngStyle]="{ background: i % 2 != 0 ? 'rgb(60,60,60)' : '' }"
              src="../../assets/icon/device-list/ellipsis.svg"
              alt=""
              srcset=""
              (click)="
                this.view_manage_user = true;
                this.manage_user_id = user.account_id.toString();
                this.manage_user_name = user.account_name;
                this.manage_user_email = user.account_email
              "
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="block" *ngIf="this.view_manage_user">
  <div>
    <p class="title">Manage user</p>
  </div>
  <div>
    <div
      class="list_message"
      style="text-decoration: underline; cursor: pointer"
      (click)="this.view_manage_user = false"
    >
      Back to users
    </div>
  </div>

  <div class="app-profile">
    <app-profile
      *ngIf="this.view_manage_user"
      [id]="this.manage_user_id"
    ></app-profile>
  </div>
  <hr />
  <div class="app-password">
    <app-password
      *ngIf="this.view_manage_user"
      [id]="this.manage_user_id"
      [update_token]="false"
    ></app-password>
  </div>
</div>
